// extracted by mini-css-extract-plugin
export default {"cardscontainer":"Business_cardscontainer__Mn2WZ","cards":"Business_cards__qkS8I"};